<template>
  <div class="relative" ref="root">
    <button
      type="button"
      class="wh-trigger"
      :class="[open ? 'wh-trigger-open' : '', disabled ? 'cursor-not-allowed opacity-60 hover:bg-white dark:hover:bg-slate-800' : '']"
      :disabled="disabled"
      @click="toggle"
      @keydown.escape="open = false"
      @keydown.down.prevent="!disabled && (open = true)">
      <span class="truncate" :class="selectedLabel ? '' : 'text-gray-400 dark:text-slate-500'">
        {{ selectedLabel || placeholder }}
      </span>
      <svg v-if="disabled" viewBox="0 0 24 24" class="h-3.5 w-3.5 shrink-0 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
      </svg>
      <svg v-else viewBox="0 0 24 24" class="h-4 w-4 shrink-0 text-gray-400 transition-transform" :class="open ? 'rotate-180' : ''" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m6 9 6 6 6-6" />
      </svg>
    </button>

    <transition name="wh-pop">
      <div v-if="open" class="wh-panel">
        <button
          v-for="opt in normalized" :key="String(opt.value)"
          type="button"
          class="wh-option"
          :class="opt.value === modelValue ? 'wh-option-active' : ''"
          @click="select(opt.value)">
          <span class="truncate">{{ opt.label }}</span>
          <svg v-if="opt.value === modelValue" viewBox="0 0 24 24" class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'WhSelect',
  props: {
    modelValue: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] }, // [{ value, label }] ou ['a','b']
    placeholder: { type: String, default: 'Sélectionner…' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return { open: false }
  },
  computed: {
    normalized() {
      return this.options.map(o =>
        typeof o === 'object' ? { value: o.value, label: o.label } : { value: o, label: String(o) })
    },
    selectedLabel() {
      const found = this.normalized.find(o => o.value === this.modelValue)
      return found ? found.label : ''
    },
  },
  methods: {
    toggle() { if (!this.disabled) this.open = !this.open },
    select(value) {
      this.open = false
      if (value !== this.modelValue) this.$emit('update:modelValue', value)
    },
    onDocClick(e) {
      if (this.open && this.$refs.root && !this.$refs.root.contains(e.target)) this.open = false
    },
  },
  mounted() { document.addEventListener('mousedown', this.onDocClick) },
  beforeUnmount() { document.removeEventListener('mousedown', this.onDocClick) },
}
</script>
